export default __webpack_public_path__ + "static/media/header-XC60.f9651bd5.jpg";